import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { getPurchaseData } from '../../../lib/use-cases/get-purchase';
import { disableScroll, enableScroll } from '../../shared/scroll';
import styles from './PurchaseSuccessModal.css';

const cx = classnames.bind(styles);

const CLOSE_ANIMATION_MS = 300;

function PurchaseSuccessModal() {
    const { planName, discount } = getPurchaseData();
    const dialogRef = useRef(null);
    const [isClosing, setIsClosing] = useState(false);

    const close = () => {
        if (isClosing) return;

        setIsClosing(true);
        setTimeout(() => {
            dialogRef.current?.close();
            enableScroll();
        }, CLOSE_ANIMATION_MS);
    };

    const handleDialogClick = e => {
        if (e.target === dialogRef.current) {
            close();
        }
    };

    const handleDialogCancel = e => {
        e.preventDefault();
        close();
    };

    useEffect(() => {
        dialogRef.current?.showModal();
        disableScroll();

        return () => {
            enableScroll();
        };
    }, []);

    return (
        <dialog
            ref={dialogRef}
            aria-labelledby='success-modal-title'
            className={cx('root', { closing: isClosing })}
            onClick={handleDialogClick}
            onCancel={handleDialogCancel}
        >
            <p id='success-modal-title' className={styles.title}>You&apos;re All Set</p>
            <p className={styles.description}>
                You&apos;ve successfully purchased the <strong>{planName || 'your plan'}</strong> on <strong>Futureproof.app</strong>{discount ? ` at ${discount}% off` : ''}.
            </p>
            <Button label='Continue' onClick={close} className={styles.button} />
        </dialog>
    );
}

export {
    PurchaseSuccessModal
};
